var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsalticon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.875 3.1875H51V51H0V0.921387L31.875 32.7964V3.1875ZM3.1875 47.8125H42.3589L3.1875 8.64111V47.8125ZM43.7036 44.625L46.8911 47.8125H47.8125V6.375H35.0625V9.5625H41.4375V12.75H35.0625V15.9375H41.4375V19.125H35.0625V22.3125H44.625V25.5H35.0625V28.6875H41.4375V31.875H35.0625V35.0625H41.4375V38.25H37.3286L40.5161 41.4375H44.625V44.625H43.7036ZM9.5625 26.4214L24.5786 41.4375H9.5625V26.4214ZM12.75 34.1411V38.25H16.8589L12.75 34.1411Z",
    fill: "#173F84"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsalticon2);
export default __webpack_public_path__ + "static/media/consalticon2.a909ef79c6524cf984c6fb88c314c124.svg";
export { ForwardRef as ReactComponent };